import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class CancellationService {

    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router
    ) {
        this.init();
    }

    /**
     * @describe Redirects the user to the cancel-booking page.
     * This service/method listens to see if a query param of cancellationId exists. If it does, this means
     * a user has navigated to the app via a cancellation link in an email. When this occures, we want to take
     * the user directly to the cancel-booking page.
     */
    init() {
        this.activatedRoute.queryParams.subscribe(queryParams => {
            if (queryParams.cancellationId) {
                this.router.navigate(['/cancel-booking', queryParams.cancellationId], {
                    skipLocationChange: true
                });
            }
        });
    }
}
